<ideal-wire-cut-cart-item-summary-view [itemId]="id()" [quantity]="cartItemQuantity()" />
